import { Box, SxProps, useTheme } from "@mui/material";

export enum BybStickerVariant {
  CIRCLE = "circle",
  SQUARE = "square",
}

interface IBybSticker {
  children: React.ReactNode;
  anchor: "top-right" | "bottom-right" | "bottom-left" | "top-left" | "center" | "none";
  margin?: number;
  size?: "small" | "medium" | "large" | "xl";
  variant?: `${BybStickerVariant}`;
  sx?: SxProps;
  className?: string;
}

const BybSticker = ({ children, anchor, margin = 0, size = "medium", variant = BybStickerVariant.CIRCLE, sx, className }: IBybSticker) => {
  const theme = useTheme();

  let size_ = 4; // medium
  let border_ = "3px";
  let borderRadius_ = "14px";
  if (size === "small") {
    size_ = 1.75;
    border_ = "2px";
    borderRadius_ = "6px";
  } else if (size === "large") {
    size_ = 8;
    border_ = "4px";
    borderRadius_ = "22px";
  } else if (size === "xl") {
    size_ = 11.5;
    border_ = "4px";
    borderRadius_ = "32px";
  }

  const classes = {
    "top-right": {
      top: theme.spacing(margin),
      right: theme.spacing(margin),
    },
    "bottom-right": {
      bottom: theme.spacing(margin),
      right: theme.spacing(margin),
    },
    "bottom-left": {
      bottom: theme.spacing(margin),
      left: theme.spacing(margin),
    },
    "top-left": {
      top: theme.spacing(margin),
      left: theme.spacing(margin),
    },
    center: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
    none: {},
  };

  return (
    <Box
      className={className}
      sx={{
        position: anchor !== "none" ? "absolute" : "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: theme.spacing(size_),
        height: theme.spacing(size_),
        backgroundColor: "dsBase.v100",
        borderRadius: variant === BybStickerVariant.CIRCLE ? "50%" : borderRadius_,
        border: `${border_} solid ${theme.palette.dsBase.v100}`,
        overflow: "hidden",
        ...classes[anchor],
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default BybSticker;
